import type { BackendClient } from '@mimir/common/util/backendClient';
import type { CropImageRequest, CropImageResponse } from '@mimir/common/dto/cropImageDtos';
import { apiPost } from '@mimir/common/util/http';
import { assumeResultObject } from '@mimir/common/client/assumeResult';

export function api_postCropImage(c: BackendClient, req: CropImageRequest): Promise<CropImageResponse> {
  return apiPost(c.getApiClient(), c.getServiceLinks().cropImage, req).then(result => assumeResultObject<CropImageResponse>(result, 'createdItem'));
}
